import { render, staticRenderFns } from "./ProjectPostingRevisionRestoreModal.vue?vue&type=template&id=608441b1"
import script from "./ProjectPostingRevisionRestoreModal.vue?vue&type=script&lang=js"
export * from "./ProjectPostingRevisionRestoreModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports